export default "__VITE_ASSET__B$2_xpFt__"